import React, { useEffect, useRef } from 'react';
import './style.scss';
import { useDisableScrollInModal } from 'hooks/useDisableScrollInModal';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getTranslationEmptyOrNullKey } from 'utils/getTranslation';
import { renderMultiKeyStrongText } from 'utils/textHtml/renderMultiKeysStronText';
import { isKeysInApa } from 'utils/apa/isKeysInApa';
const keysErroText = [
  'MDP_MetodosDePago_ModalError_Parrafo_Texto1_telmexmexicogate',
  'MDP_MetodosDePago_ModalError_Parrafo_Texto2_telmexmexicogate',
  'MDP_MetodosDePago_ModalError_Parrafo_Texto3_telmexmexicogate',
];
const keysSuccessText = [
  'MDP_MetodosDePago_ModalVerificacion_Parrafo_Texto1_telmexmexicogate',
  'MDP_MetodosDePago_ModalVerificacion_Parrafo_Texto2_telmexmexicogate',
];
const ConfirmPaymentModal = ({ time, type, closeModal, gateway }) => {
  const assets = useSelector(state => state.asset);
  const successIcon = assets?.Icono_Correcto || '';
  const errorIcon = assets?.Icono_Incorrecto || '';
  const counterTimeRef = useRef(0);
  const location = useLocation();
  const searchParam = new URLSearchParams(location.search);
  const translations = useSelector(state => state.translations);
  const telmexText1Error = getTranslationEmptyOrNullKey(
    `MDP_MetodosDePago_ModalError_Parrafo_Texto1_${gateway}`,
    translations,
  );
  const telmexText2Error = getTranslationEmptyOrNullKey(
    `MDP_MetodosDePago_ModalError_Parrafo_Texto2_${gateway}`,
    translations,
  );
  const telmexText3Error = getTranslationEmptyOrNullKey(
    `MDP_MetodosDePago_ModalError_Parrafo_Texto3_${gateway}`,
    translations,
  );
  const telmexText1Success = getTranslationEmptyOrNullKey(
    `MDP_MetodosDePago_ModalVerificacion_Parrafo_Texto1_${gateway}`,
    translations,
  );
  const telmexText2Success = getTranslationEmptyOrNullKey(
    `MDP_MetodosDePago_ModalVerificacion_Parrafo_Texto2_${gateway}`,
    translations,
  );
  const navigate = useNavigate();
  useDisableScrollInModal();
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (counterTimeRef.current >= time) {
        if (type === 'error') return closeModal();
        return navigate(`${location.pathname}?${searchParam.toString()}`, {
          state: { ...location.state, screen: 'checkout' },
        });
      }

      counterTimeRef.current = counterTimeRef.current + 1;
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const renderTextModal = (keys, textHtml, isKeysInApa, maxLenth) => {
    return renderMultiKeyStrongText(isKeysInApa, keys, maxLenth, textHtml);
  };

  const renderTextDescription = () => {
    if (type === 'error')
      return renderTextModal(
        `${telmexText1Error} ${telmexText2Error} ${telmexText3Error}`,
        <p className="text-description-error-add-telmex">
          {} {telmexText1Error} <strong>{telmexText2Error}</strong>{' '}
          {telmexText3Error}
        </p>,
        isKeysInApa(keysErroText, translations),
        95,
      );
    return renderTextModal(
      `${telmexText1Success} ${telmexText2Success}`,
      <p className="text-description-success-add-telmex">
        <strong>{telmexText1Success}</strong> {telmexText2Success}
      </p>,
      isKeysInApa(keysSuccessText, translations),
      65,
    );
  };
  return (
    <div className="confirm-payment-modal-container">
      <div className="confirm-payment-modal-container-card-container">
        <div className="confirm-payment-modal-container-card-subcontainer">
          <img
            className="confirm-payment-modal-container-card-icon"
            src={type === 'error' ? errorIcon : successIcon}
          />
          {renderTextDescription()}
        </div>
      </div>
    </div>
  );
};

export default ConfirmPaymentModal;
